import React from 'react';
import { HStack, ScrollView, VStack, SimpleGrid, IconButton } from 'native-base';
import { t } from 'i18next';
import { map } from 'lodash';

import { Expand01Icon, Text } from '@pimm/base';
import { CalendarEvent, CalendarEventType } from '../context/calendar-events-context';
import { CalendarDateIcon, GiftIcon } from '../icons';
import { CalendarEventColor } from '../_helper';
import { EmployeeEventBadge } from './employee-event-badge';

type EmployeeCelebrationListProps = React.ComponentProps<typeof HStack> & {
  celebrationType: CalendarEventType;
  data?: CalendarEvent[];
  date: Date;
};

export const EmployeeCelebrationList = ({ celebrationType, data = [], date, ...props }: EmployeeCelebrationListProps) => {
  const eventColor = CalendarEventColor[celebrationType];

  return (
    <VStack flex={1} p={2} pt={3} space={3} rounded="lg" bgColor={`${eventColor}.200`} {...props}>
      <HStack space={2} alignItems="center">
        {celebrationType === 'Birthday' ? <GiftIcon /> : <CalendarDateIcon />}
        <Text size="md" flex={1} fontWeight={600} color={`${eventColor}.900`} lineHeight="xs" numberOfLines={1} ellipsizeMode="tail">
          {celebrationType === 'Birthday' ? `${t('calendar:birthday')}` : `${t('calendar:anniversary')}`}
        </Text>
      </HStack>

      <ScrollView flex={1}>
        {celebrationType === 'Anniversary' ? (
          <SimpleGrid columns={data.length > 8 ? 2 : 1} space={1.5}>
            {map(data, _event => (
              <EmployeeEventBadge key={`${celebrationType}.${_event.referenceId}`} date={date} event={_event} />
            ))}
          </SimpleGrid>
        ) : (
          <VStack flex={1} space={1.5}>
            {map(data, _event => (
              <EmployeeEventBadge key={`${celebrationType}.${_event.referenceId}`} date={date} event={_event} />
            ))}
          </VStack>
        )}
      </ScrollView>
    </VStack>
  );
};
